import {InjectionToken} from '@angular/core';

export const UNAUTHORIZED_REDIRECT_PATH = new InjectionToken<string>('Redirect all unauthorized/unauthenticated users to this path');
